const ACTION_STATUS_MODIFIER = {
  complete: "online",
  pending: "processing",
};

// Maps an action/job status string to a kinetica-status-pill modifier.
// Anything not in the table falls through to "error" so anomalies stay visible
// rather than silently rendering as a benign neutral chip.
export const getActionStatusModifier = (status) =>
  ACTION_STATUS_MODIFIER[status] ?? "error";

const StatusPill = ({ modifier, style, children }) => (
  <span
    className={`kinetica-status-pill kinetica-status-pill--${modifier}`}
    style={{ justifyContent: "center", ...style }}
  >
    {children}
  </span>
);

export default StatusPill;
